<template>
  <div class=" my-8">
    <p class="featured-heading ml-4" style="margin-top: 14px; font-weight: 500; font-family: BrooklynSamuelsFive-Medium, monospace !important; margin-left: 24px;">Proud To Partner With</p>

    <div class="partnership-carousel-container">
      <div
        ref="carouselScrollDiv"
        class="partnership-carousel-wrapper"
        @mouseenter="pauseAutoScroll"
        @mouseleave="resumeAutoScroll"
      >
        <div class="carousel-track" :style="{ transform: `translateX(${scrollPosition}px)` }">
          <v-card
            v-for="(partner, index) in partners"
            :key="`first-${index}`"
            class="mx-4 d-flex align-center justify-center no-border-card carousel-item"
            width="170"
            height="100"
            elevation="0"
          >
            <v-img :src="partner.icon" :alt="partner.name" contain class="carousel-image" />
          </v-card>

          <v-card
            v-for="(partner, index) in partners"
            :key="`second-${index}`"
            class="mx-4 d-flex align-center justify-center no-border-card carousel-item"
            width="170"
            height="100"
            elevation="0"
          >
            <v-img :src="partner.icon" :alt="partner.name" contain class="carousel-image" />
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PartnerLogosCarousel",
  data() {
    return {
      partners: [
        { name: 'Bandt', icon: require('@/assets/img/jobs.png') },
        { name: 'Embed', icon: require('@/assets/img/embed.png') },
        { name: 'XYZ', icon: require('@/assets/img/liznable.png') },
        { name: 'ABC', icon: require('@/assets/img/Group42.png') },
        { name: 'MNO', icon: require('@/assets/img/image8.png') },
        { name: 'Bandt', icon: require('@/assets/img/jobs.png') },
        { name: 'Embed', icon: require('@/assets/img/embed.png') },
        { name: 'XYZ', icon: require('@/assets/img/liznable.png') },
        { name: 'ABC', icon: require('@/assets/img/Group42.png') },
        { name: 'MNO', icon: require('@/assets/img/image8.png') }
      ],
      autoScrollInterval: null,
      scrollPosition: 0,
      scrollSpeed: 1,
      itemWidth: 202, // card + margin
      isPaused: false
    };
  },
  mounted() {
    // Initialize starting position to show seamless loop
    this.scrollPosition = -this.partners.length * this.itemWidth;
    this.startAutoScroll();
  },
  beforeDestroy() {
    this.stopAutoScroll();
  },
  methods: {
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        if (!this.isPaused) {
          // Move left to right (positive direction)
          this.scrollPosition += this.scrollSpeed;
          
          // Reset position when first set is completely out of view
          if (this.scrollPosition >= 0) {
            this.scrollPosition = -this.partners.length * this.itemWidth;
          }
        }
      }, 12);
    },
    stopAutoScroll() {
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }
    },
    pauseAutoScroll() {
      this.isPaused = true;
    },
    resumeAutoScroll() {
      this.isPaused = false;
    }
  }
};
</script>

<style scoped lang="stylus">
.partnership-carousel-container
  overflow hidden
  position relative
  width 100%
  padding 20px 0

.partnership-carousel-wrapper
  display flex
  align-items center
  white-space nowrap
  overflow hidden

.carousel-track
  display flex
  will-change transform
  transition transform 0.1s linear

.carousel-item
  flex none

.carousel-item:hover
  transform scale(1.5)      
  transition transform 0.3s ease-in-out


.carousel-image
  max-height 80px
  max-width 150px
</style>


// WEBPACK FOOTER //
// src/views/app/home/components/PartnerLogosCarousel.vue